import React, { useState, useEffect, FormEvent } from "react";
import {
  Box,
  Text,
  Input,
  Button,
  VStack,
  Heading,
} from "@chakra-ui/react";
import { useLoginMutation } from "../services/authApi";
import { useNavigate } from "@tanstack/react-router";
import { useAppDispatch } from "../store/hooks";
import { setCredentials } from "../store/authSlice";

const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [triggerLogin, { data, isLoading, error }] = useLoginMutation();

  useEffect(() => {
    if (data?.jwt && data?.user) {
      dispatch(setCredentials({ user: data.user, jwt: data.jwt }));
      navigate({ to: "/" });
    }
  }, [data, navigate, dispatch]);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    await triggerLogin({ username, password });
  };

  return (
    <Box
      maxW="sm"
      mx="auto"
      mt={10}
      p={6}
      bg="white"
      borderRadius="xl"
      boxShadow="md"
    >
      <form onSubmit={handleSubmit}>
        <VStack gap={4}>
          <Heading size="lg">Login</Heading>

          {error && (
            <Text fontSize="sm" color="red.500">
              Failed to log in. Check credentials.
            </Text>
          )}

          <Box width="100%">
            <Text mb={1}>Username</Text>
            <Input
              id="username"
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
          </Box>

          <Box width="100%">
            <Text mb={1}>Password</Text>
            <Input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </Box>

          <Button
            type="submit"
            width="100%"
            data-loading={isLoading ? "true" : undefined}
            colorScheme="blue"
          >
            Login
          </Button>
        </VStack>
      </form>
    </Box>
  );
};

export default Login;